import React from 'react';
import './AppFooter.css';

const AppFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <a href="https://xem.luansodienthoai.com">Luận Số Điện Thoại</a>
      {' '}©{currentYear} - Phát triển bởi{' '}
      <a href="https://www.facebook.com/lethebinh13" target="_blank" rel="noopener noreferrer">
        Lê Thế Bình
      </a>
    </footer>
  );
};

export default AppFooter;
